
import Entity from './Entity'
import User from './Users'
const exportObj = {
    Entity, User
}

export default exportObj